import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useLogout } from "#modules/auth/infra/useLogout";
import { CreateCompanyDto } from "#modules/company/infra/createCompany.api";
import { useCreateCompany } from "#modules/company/view/useCreateCompany";
import { Center } from "#shared/view/components/Center";
import { Button } from "#shared/view/designSystem/Button";
import { TextInput } from "#shared/view/designSystem/inputs/TextInput";

interface onCreateNewCompanyProps {
  onCreateCompanyClick: () => void;
}

export function CreateNewCompany({ onCreateCompanyClick }: onCreateNewCompanyProps) {
  const { logout } = useLogout();
  const { createCompany, isPending } = useCreateCompany({
    onSuccess: async () => {
      await logout();
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CreateCompanyDto>();

  const { t } = useTranslation();

  const onSubmit = async (data: CreateCompanyDto) => {
    createCompany(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ minWidth: 400 }}>
      <Center>
        <TextInput
          style={{ minWidth: 400 }}
          withAsterisk
          label={t("login.companyName")}
          error={errors.name ? t("login.companyNameRequired") : null}
          {...register("name", {
            required: true,
          })}
        />
      </Center>
      <Center>
        <Button mt="xs" size="md" loading={isPending} variant="filled" type="submit">
          {t("login.startQuoting")}
        </Button>
      </Center>
      <Center>
        <Link
          to="#"
          onClick={onCreateCompanyClick}
          style={{ color: "black", fontSize: "12px", marginTop: 5 }}
        >
          {t("login.myCompanyExists")}
        </Link>
      </Center>
    </form>
  );
}
